module.exports = __webpack_public_path__ + "apple-touch-icon.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/favicons/apple-touch-icon.png
// module id = 368
// module chunks = 0